import React, { Component, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import "./pdf.css";
import { Button } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import Ph9FormPdf from "./Ph9FormPdf";
import { bindActionCreators } from "redux";
import * as dropDownActions from "../../../../../actionCreators/DropDown";
import { useState } from "react";

const Ph9Form = ({
  currentProperty,
  propertyClassifications,
  getPropertyClassifications,
}) => {
  const history = useHistory();
  const [dataWithClassifications, setdataWithClassifications]=useState(null)

  useEffect(() => {
    if (currentProperty?.data != null) {
      if (
        currentProperty.data.data.change_requests[0].changed_data
          .khasra_number_id
      ) {
        getPropertyClassifications({
          valuation_data_id:
            currentProperty.data.data.change_requests[0].changed_data
              .khasra_number_id,
        });
      } else {
        getPropertyClassifications({
          valuation_data_id: currentProperty.data.data.valuation_data_id,
        });
      }
    }
  }, [currentProperty]);
  useEffect(() => {
    if (currentProperty?.data != null && propertyClassifications?.length !== 0) {
      setdataWithClassifications({...currentProperty.data.data, propertyClassifications});
    }
  }, [propertyClassifications]);
  useEffect(() => {
    if (currentProperty?.data != null && dataWithClassifications!==null) {
      const input = document.getElementById("Artboard__1");
      html2canvas(input).then((canvas) => {
        var imgWidth = 200;
        var pageHeight = 250;
        // var imgHeight = (canvas.height * imgWidth) / canvas.width;
        var imgHeight = 330;
        var heightLeft = imgHeight;
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF();
        var position = -20;
        var heightLeft = imgHeight;
        pdf.addImage(imgData, "JPEG", 5, position, imgWidth, imgHeight);
        // pdf.save("download1.pdf");
        window.open(pdf.output("bloburl"), "_blank");
      });
    }
  }, [currentProperty, dataWithClassifications]);
  if (currentProperty?.data != null && dataWithClassifications!==null) {
    return (
      <React.Fragment>
        {currentProperty?.data && (
          <div
            id="Artboard__1"
            style={{
              //   background: "blue",
              width: "85%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              //   height: "fit-content",
              marginLeft: 90,
            }}
          >
            <Ph9FormPdf data={dataWithClassifications} />
          </div>
        )}
        <div className="close-button-section">
          <Button
            className="close-button"
            // type="primary"
            onClick={() => {
              history.goBack();
            }}
          >
            <ArrowLeftOutlined />
            <span>Back</span>
          </Button>
        </div>
      </React.Fragment>
    );
  } else {
    return <div></div>;
  }
};

const mapStateToProps = ({
  property: { currentProperty },
  dropDown: { propertyClassifications },
}) => ({
  currentProperty,
  propertyClassifications,
});

const mapDispatchToProps = (dispatch) => ({
  getPropertyClassifications: bindActionCreators(
    dropDownActions.getPropertyClassifications,
    dispatch
  ),
});

Ph9Form.propTypes = {
  currentProperty: PropTypes.object.isRequired,
  propertyClassifications: PropTypes.array.isRequired,
  getPropertyClassifications: PropTypes.func.isRequired,
};
export default connect(mapStateToProps, mapDispatchToProps)(Ph9Form);
